import React, { useEffect } from 'react'
import mediumZoom from 'medium-zoom';

const VitalityBoxShipping = () => {
   useEffect(() => {
    const zoom = mediumZoom(".zoomable", {
      margin: 24,
      background: "#000",
      scrollOffset: 0,
    });
    return () => {
      zoom.detach();
    };
  }, []);
  return (
 
            <div className="flex flex-col-reverse md:flex-col">
              <p className="mt-6 text-[#233751] font-bold text-[20px] text-center px-4 italic bold-font md:pb-3 pb-8">
                I'm super excited and ready to ship your Vitality Box out to you
                today...
              </p>

              <div className="flex items-center justify-center pt-4 md:pb-16 pb-0">
                <div className="flex flex-col items-center md:space-y-8 space-y-0">
                  <div className="flex space-x-4">
                    <img
                      src="https://cdn.blackincae.com/YhU-cgmp-1-.svg"
                      alt=""
                      className="w-[60px] h-[60px] object-cover transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                    <img
                      src="https://cdn.blackincae.com/Oro-fda-1-.svg"
                      alt=""
                      className="w-[60px] h-[60px] object-cover transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                    <img
                      src="https://cdn.blackincae.com/TjQ-madeinusa-1-.svg"
                      alt=""
                      className="w-[60px] h-[60px] object-cover transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                    <img
                      src="https://cdn.blackincae.com/MmB-nongmo-1-.svg"
                      alt=""
                      className="w-[60px] h-[60px] object-cover transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                  <div className="hidden md:block">
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-4 px-4">
                      <div className="relative group">
                        <img
                          src="https://cdn.blackincae.com/waH-lungs-b.png"
                          alt="Image 1"
                          className="w-full h-full object-cover zoomable shadow medium-zoom-image zoomable "
                        />
                        <div className="zoom-icon absolute top-[35%] right-[45%] text-white p-2 text-xl opacity-0 group-hover:opacity-100 transition duration-300 cursor-pointer z-10 flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-14 h-14"
                            viewBox="0 0 73 72"
                            fill="none"
                          >
                            <rect
                              x="0.5"
                              width="72"
                              height="72"
                              rx="6"
                              fill="#233751"
                              fillOpacity="0.9"
                            />
                            <path
                              d="M47 42H44.63L43.79 41.19C46.73 37.77 48.5 33.33 48.5 28.5C48.5 17.73 39.77 9 29 9C18.23 9 9.5 17.73 9.5 28.5C9.5 39.27 18.23 48 29 48C33.83 48 38.27 46.23 41.69 43.29L42.5 44.13V46.5L57.5 61.47L61.97 57L47 42ZM29 42C21.53 42 15.5 35.97 15.5 28.5C15.5 21.03 21.53 15 29 15C36.47 15 42.5 21.03 42.5 28.5C42.5 35.97 36.47 42 29 42Z"
                              fill="white"
                            />
                            <path
                              d="M36.5 30H30.5V36H27.5V30H21.5V27H27.5V21H30.5V27H36.5V30Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>

                      <div className="relative group">
                        <img
                          src="https://cdn.blackincae.com/DGC-bedtime-b.png"
                          alt="Image 2"
                          className="w-full h-full object-cover zoomable shadow"
                        />
                        <div className="zoom-icon absolute top-[35%] right-[45%] text-white p-2 text-xl opacity-0 group-hover:opacity-100 transition duration-300 cursor-pointer z-10 flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-14 h-14"
                            viewBox="0 0 73 72"
                            fill="none"
                          >
                            <rect
                              x="0.5"
                              width="72"
                              height="72"
                              rx="6"
                              fill="#233751"
                              fillOpacity="0.9"
                            />
                            <path
                              d="M47 42H44.63L43.79 41.19C46.73 37.77 48.5 33.33 48.5 28.5C48.5 17.73 39.77 9 29 9C18.23 9 9.5 17.73 9.5 28.5C9.5 39.27 18.23 48 29 48C33.83 48 38.27 46.23 41.69 43.29L42.5 44.13V46.5L57.5 61.47L61.97 57L47 42ZM29 42C21.53 42 15.5 35.97 15.5 28.5C15.5 21.03 21.53 15 29 15C36.47 15 42.5 21.03 42.5 28.5C42.5 35.97 36.47 42 29 42Z"
                              fill="white"
                            />
                            <path
                              d="M36.5 30H30.5V36H27.5V30H21.5V27H27.5V21H30.5V27H36.5V30Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>

                      <div className="relative group">
                        <img
                          src="https://cdn.blackincae.com/OZg-bonerenew-b.png"
                          alt="Image 3"
                          className="w-full h-full object-cover zoomable shadow"
                        />
                        <div className="zoom-icon absolute top-[35%] right-[45%] text-white p-2 text-xl opacity-0 group-hover:opacity-100 transition duration-300 cursor-pointer z-10 flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-14 h-14"
                            viewBox="0 0 73 72"
                            fill="none"
                          >
                            <rect
                              x="0.5"
                              width="72"
                              height="72"
                              rx="6"
                              fill="#233751"
                              fillOpacity="0.9"
                            />
                            <path
                              d="M47 42H44.63L43.79 41.19C46.73 37.77 48.5 33.33 48.5 28.5C48.5 17.73 39.77 9 29 9C18.23 9 9.5 17.73 9.5 28.5C9.5 39.27 18.23 48 29 48C33.83 48 38.27 46.23 41.69 43.29L42.5 44.13V46.5L57.5 61.47L61.97 57L47 42ZM29 42C21.53 42 15.5 35.97 15.5 28.5C15.5 21.03 21.53 15 29 15C36.47 15 42.5 21.03 42.5 28.5C42.5 35.97 36.47 42 29 42Z"
                              fill="white"
                            />
                            <path
                              d="M36.5 30H30.5V36H27.5V30H21.5V27H27.5V21H30.5V27H36.5V30Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>

                      <div className="relative group">
                        <img
                          src="https://cdn.blackincae.com/oYX-bioreform-b.png"
                          alt="Image 4"
                          className="w-full h-full object-cover zoomable shadow"
                        />
                        <div className="zoom-icon absolute top-[35%] right-[45%] text-white p-2 text-xl opacity-0 group-hover:opacity-100 transition duration-300 cursor-pointer z-10 flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-14 h-14"
                            viewBox="0 0 73 72"
                            fill="none"
                          >
                            <rect
                              x="0.5"
                              width="72"
                              height="72"
                              rx="6"
                              fill="#233751"
                              fillOpacity="0.9"
                            />
                            <path
                              d="M47 42H44.63L43.79 41.19C46.73 37.77 48.5 33.33 48.5 28.5C48.5 17.73 39.77 9 29 9C18.23 9 9.5 17.73 9.5 28.5C9.5 39.27 18.23 48 29 48C33.83 48 38.27 46.23 41.69 43.29L42.5 44.13V46.5L57.5 61.47L61.97 57L47 42ZM29 42C21.53 42 15.5 35.97 15.5 28.5C15.5 21.03 21.53 15 29 15C36.47 15 42.5 21.03 42.5 28.5C42.5 35.97 36.47 42 29 42Z"
                              fill="white"
                            />
                            <path
                              d="M36.5 30H30.5V36H27.5V30H21.5V27H27.5V21H30.5V27H36.5V30Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  )
}

export default VitalityBoxShipping